import React from 'react';
import PropTypes from 'prop-types';

import * as api from './api';
import Errors from 'components/form/errors';
import Modal from 'components/modal';
import CheckCircle from 'components/svgs/check_circle';
import Form from './form';
import listingPropTypes from 'components/listing/prop_types';

export default class ListingQuickUpdateModal extends React.Component {
  static propTypes = {
    allowStatusChange: PropTypes.bool,
    availableDatabases: PropTypes.array,
    companyPercentageLikelyToCloseDefaults: PropTypes.object,
    draggedToListingStatus: PropTypes.string,
    features: PropTypes.shape({
      backoffice: PropTypes.bool,
      pipeline: PropTypes.bool,
    }).isRequired,
    listing: listingPropTypes.isRequired,
    show: PropTypes.bool,
    showClosingMessage: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onClose: PropTypes.func,
    onSave: PropTypes.func.isRequired
  };

  state = {
    errors: [],
    listing: { ...this.props.listing }
  };

  componentDidUpdate(previousProps) {
    if (this.props.show && !previousProps.show) {
      const listing = { ...this.props.listing };

      if (this.props.draggedToListingStatus) {
        listing.listingStatus = this.props.draggedToListingStatus;
      }

      this.setState({ listing });
    }
  }

  cancel = () => {
    this.setState({ errors: [] });

    this.props.onCancel();
  };

  save = () => {
    this.setState({ errors: [], saving: true });

    api.save(this.state.listing)
      .then((listing) => {
        let newState = { saving: false };

        if (this.state.listing.listingStatus === 'closed' && this.props.showClosingMessage) {
          newState = { ...newState, listing, renderClosingMessage: true };
        }

        this.props.onSave(listing);
        this.setState(newState);
      })
      .catch((errors = ['Something went wrong.']) => {
        this.setState({ errors, saving: false });
      });
  };

  handleChange = (changes) => {
    this.setState(state => ({ listing: { ...state.listing, ...changes } }));
  };

  render() {
    const detailsLabel = this.state.listing.listingStatus === 'closed' ? 'Deal Details' : 'Prediction Details';

    return (
      <Modal
        show={this.props.show}
        onHide={this.props.onCancel}
      >
        <Modal.Header closeButton>
          {this.state.renderClosingMessage ? 'Listing Closed' : detailsLabel}
        </Modal.Header>

        <Modal.Body>
          <Errors description={false} errors={this.state.errors} />
          {this.state.renderClosingMessage ? this.renderClosingMessage() : this.renderForm()}
        </Modal.Body>

        <Modal.Footer>
          {this.renderControls()}
        </Modal.Footer>
      </Modal>
    );
  }

  renderControls() {
    if (this.state.renderClosingMessage) {
      return (
        <button
          className="btn btn-primary"
          name="close"
          onClick={this.props.onClose}
        >
          Close
        </button>
      );
    } else {
      return <React.Fragment>
        <button
          className="btn btn-ghost"
          name="cancel"
          onClick={this.cancel}
        >
          Cancel
        </button>
        <button
          className="btn btn-primary"
          disabled={this.state.saving}
          name="save"
          onClick={this.save}
        >
          Save
        </button>
      </React.Fragment>;
    }
  }

  renderForm() {
    return (
      <Form
        allowStatusChange={this.props.allowStatusChange}
        availableDatabases={this.props.availableDatabases}
        companyPercentageLikelyToCloseDefaults={this.props.companyPercentageLikelyToCloseDefaults}
        features={this.props.features}
        listing={this.state.listing}
        updatingStatusByDragging={this.props.draggedToListingStatus != null}
        onChange={this.handleChange}
      />
    );
  }

  renderClosingMessage() {
    const voucherPath = this.state.listing.voucher.path;
    const { backoffice } = this.props.features;

    return (
      <div className="text-center">
        <CheckCircle animate />
        <h3>This listing has been successfully closed!</h3>
        {voucherPath && backoffice && (
          <a href={`${voucherPath}?back_to=/pipeline`} name="voucher-link">
            You can enter more in-depth closing details here.
          </a>
        )}
      </div>
    );
  }
}

